import { render, staticRenderFns } from "./WebsitesPercentages.vue?vue&type=template&id=25b42d54&"
import script from "./WebsitesPercentages.vue?vue&type=script&lang=js&"
export * from "./WebsitesPercentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports